module.exports = __webpack_public_path__ + "static/media/avatar_hero.43bb90cf.png";